import { IApplicationState } from '../../types/redux';

export function selectComparisonAlbums(state: IApplicationState) {
  return state.comparisonAlbums.comparisonAlbums;
}
